<template>
    <section class="RichtextElement ContentSection" v-html="properties.text"></section>
</template>
<script>
export default {
    props: ["properties", "pageData"]
}
</script>
<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';

.RichtextElement {
    text-align: left;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 120px;
    padding-bottom: 80px;

    >p {
        margin-bottom: 24px;
    }

    @include mobile-only {
        padding-top: 80px;
        padding-bottom: 30px;
    }
}
</style>